(() => {
  'use strict';
  function checkoutURL(rows, products) {
    if (!Array.isArray(rows) || !rows.length) throw new Error('Choisissez un bijou pour continuer.');
    const items = new Map();
    let count = 0;
    for (const row of rows) {
      const product = products.find(p => p.id === row.id);
      const variant = product?.variants.find(v => v.name === row.variant);
      const id = variant?.id?.match(/^gid:\/\/shopify\/ProductVariant\/(\d+)$/)?.[1];
      if (!id || variant.availableForSale === false || product.onlineStoreUrl === null) {
        throw new Error('Veuillez choisir à nouveau le modèle de ce bijou.');
      }
      if (!Number.isInteger(row.qty) || row.qty < 1 || row.qty > 5) {
        throw new Error('Veuillez vérifier les quantités de votre sélection.');
      }
      count += row.qty;
      items.set(id, (items.get(id) || 0) + row.qty);
    }
    if (count > 5) throw new Error('Votre sélection peut contenir jusqu’à 5 bijoux.');
    const path = Array.from(items, ([id, qty]) => `${id}:${qty}`).join(',');
    return `https://www.amelieatelier.com/cart/${path}?locale=fr`;
  }
  window.ELISE_SHOPIFY = Object.freeze({ checkoutURL });
})();
